export function useMaxDate() {
  const date = new Date();

  const toString = (number) => (number < 10 ? `0${number}` : `${number}`);

  const month = toString(date.getMonth() + 1);
  const day = toString(date.getDate());
  const year = date.getFullYear();

  const maxDate = `${year}-${month}-${day}`;

  return { maxDate };
}
